import { atom } from 'recoil';
import { QuestionnaireWithResultSets } from '../interfaces/Questionnaire';

export interface QuestionnairesListType {
  list: QuestionnaireWithResultSets[] | null;
}

export const QuestionnairesListState = atom<QuestionnairesListType>({
  key: 'QuestionnairesListState',
  default: {
    list: null,
  },
});
